import type { JSX } from 'react'

import { Text } from '@buffer-mono/popcorn'

import { GuestMediaPreview } from '~publish/components/GuestMedia'
import type { GuestMedia } from '~publish/helpers/guestMedia'
import type { GuestMediaAccessController } from '~publish/hooks/useGuestMediaAccess'

import styles from './PublicPostPreview.module.css'

export function PublicPostPreview({
  text,
  media,
  mediaAccess,
}: {
  text: string
  media: readonly GuestMedia[]
  mediaAccess: GuestMediaAccessController
}): JSX.Element {
  const hasText = text.trim().length > 0

  return (
    <div className={styles.card}>
      {hasText ? (
        <Text as="p" color="default" className={styles.text}>
          {text}
        </Text>
      ) : null}
      <GuestMediaPreview
        media={media}
        access={mediaAccess}
        className={styles.media}
      />
    </div>
  )
}
